import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { AuthStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

// The access token now lives in memory, so it is always empty on a fresh load — `authentificated`
// starts false and is driven by the bootstrap flow (silent /auth/refresh) and login/logout.
// `bootstrapped` gates the app shell until that first refresh attempt resolves.
const initialState: AuthStateType = {
  authentificated: false,
  bootstrapped: false,
};

const reducer = createReducer<AuthStateType, Action>(initialState)
  .handleAction(actions.login.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.authentificated = !!action.payload.token;
    }),
  )
  .handleAction(actions.logout.success, (state) =>
    produce(state, (nextState) => {
      nextState.authentificated = false;
    }),
  )
  .handleAction(actions.bootstrap.success, (state) =>
    produce(state, (nextState) => {
      nextState.authentificated = true;
      nextState.bootstrapped = true;
    }),
  )
  .handleAction(actions.bootstrap.failure, (state) =>
    produce(state, (nextState) => {
      nextState.authentificated = false;
      nextState.bootstrapped = true;
    }),
  );

export { reducer as AuthReducer };
